import { Injectable, Injector } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { environment } from '../../environments/environment';
import { WpTokenService } from '../core/auth/wp-token.service';
import { withBuyonlineAccessToken } from '../core/buy-insurance-access.util';

import { BaseComponents } from '../base.component';

/** Order the server created for the reference after the OTP. */
export interface PlacedOrder {
  orderTransactionUCID: string;
  orderNumber: string;
  voucherNumber: string;
  serverAmount?: string | number | null;
}

/**
 * Buy-online checkout after the OTP: the server issues the voucher / order numbers and creates
 * the order from what it stored for the reference. Only the reference and its token are sent.
 */
@Injectable()
export class PlaceOrderService extends BaseComponents {
  constructor(
    protected injectorObj: Injector,
    public httpClient: HttpClient,
    public wpTokenService: WpTokenService,
  ) {
    super(injectorObj);
  }

  private VERIFY_TOKEN_EXPIRE = false;

  httpClientOptions() {
    const httpClientOptions = {
      headers: {
        'Content-Type': 'application/json',
      },
      observe: 'response' as 'body'
    };
    if (this.VERIFY_TOKEN_EXPIRE) {
      let token = this.wpTokenService.getToken();
      httpClientOptions.headers['Authorization'] = token;
    }
    return httpClientOptions;
  }

  connector(ref: string) {
    const url = `${environment.endpointBackend}/api/services/buy-insurance/placeOrder?ref=${ref}`;
    const body = withBuyonlineAccessToken(ref, {});
    return this.httpClient.post(url, body, this.httpClientOptions());
  }

  // Core Function ! No modify
  exec(ref: string): Promise<PlacedOrder> {
    const self = this;
    return new Promise(function (resolve, reject) {
      if (!self.VERIFY_TOKEN_EXPIRE || !self.wpTokenService.isTokenExpired()) {
        self.connector(ref).subscribe(
          res => {
            self.wpTokenService.storeToken(res['headers'].get('Authorization'));
            let re = res['body'];
            if (re.status && re.data?.orderTransactionUCID) {
              resolve(re.data);
            } else {
              reject(re);
            }
          },
          err => {
            reject(err);
          }
        );
      } else {
        reject({
          name: 'WP_TOKEN_EXCEPTION',
          httpStatus: 401,
          message: 'token is expired'
        });
      }
    });
  }
}
